<script lang="ts" setup>
import type { StaticPage } from '~/types/StaticPage';

const route = useRoute();
const staticPageStore = useStaticPageStore();

const page: StaticPage | null = await staticPageStore.getStaticPageBySlug(route.path.split('/').slice(2).join('/'));

if (page?.simplePage?.seo_tags?.description?.length && !page.seoDescription) {
  page.seoDescription = page.simplePage.seo_tags.description;
}

useHead({
  title: page?.seoTitle,
  meta: [
    { name: 'description', content: page?.seoDescription ?? page?.annotation },
    { property: 'og:title', content: page?.seoTitle },
    { property: 'og:description', content: page?.seoDescription ?? page?.annotation },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: route.fullPath },
    { property: 'og:site_name', content: 'Hellride.ru' },
    { property: 'og:locale', content: 'ru_RU' },
    { property: 'og:image', content: page?.seoImage?.conversions.image_open_graph_thumb },
  ],
});

if (page?.header === 'Контакты') {
  useJsonld({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hellride',
    url: 'https://www.hellride.ru/',
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'ул. Авиаконструктора Сухого 2к1',
        addressLocality: 'Москва',
        addressRegion: 'RU',
        addressCountry: 'RU',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Рязанский проспект 3Б',
        addressLocality: 'Москва',
        addressRegion: 'RU',
        addressCountry: 'RU',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Сокольническая площадь 9',
        addressLocality: 'Москва',
        addressRegion: 'RU',
        addressCountry: 'RU',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'ул. Савушкина 119к3',
        addressLocality: 'Санкт-Петербург',
        addressRegion: 'RU',
        addressCountry: 'RU',
      },
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '88002001145',
        contactType: 'customer support',
        areaServed: 'RU',
        availableLanguage: ['Russian'],
      },
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '11:00',
        closes: '20:00',
        validFrom: '2024-03-13',
        validThrough: '2024-12-31',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '10:00',
        closes: '20:00',
        validFrom: '2024-03-13',
        validThrough: '2024-12-31',
        validFor: {
          '@type': 'PostalAddress',
          streetAddress: 'Сокольническая площадь 9',
          addressLocality: 'Москва',
          addressRegion: 'RU',
          postalCode: ' ',
          addressCountry: 'RU',
        },
      },
    ],
  });
}
</script>

<template>
  <section
    v-if="page"
    class="static-page"
  >
    <CatalogBreadcrumbsBlock :breadcrumbs="page.breadcrumbs" />

    <h1>{{ page.header }}</h1>

    <StaticPageConstructorBlocks :blocks="page.constructor" />
  </section>
</template>

<style lang="scss">
.static-page {
  @include inner-content;

  gap: 16px;
  max-width: $static-content-max-width;
}
</style>
